import './styles/graphic.scss';
import { json } from 'd3-fetch';
import { select } from 'd3-selection';
import { statesAndDc } from './utils/states';
import { formatDate } from './utils/helpers';

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    data,
  } = props;

  // If the data hasn't been loaded, load it
  if (!data) {
    // Eventually, fold these all into context.json

    // Outpatient visits
    json('https://ix.cnn.io/data/flu/v2/context.json').then((d) => {
      if (('currentWeek' in d) && ('ili_percent' in d.currentWeek)) {
        const number = document.querySelector('#number-1');
        number.innerHTML = `${d.currentWeek.ili_percent}%`;
      }
      if (('historicalComparison' in d) && ('previousSeasonSameWeekValue' in d.historicalComparison)) {
        if ('ili_percent' in d.historicalComparison.previousSeasonSameWeekValue) {
          const numberContext = document.querySelector('#number-1-context');
          numberContext.innerHTML = `, compared to ${d.historicalComparison.previousSeasonSameWeekValue.ili_percent}% this time last season`;
        }
      }
      if (('lastUpdatedStr' in d) && ('currentWeek' in d)) {
        const footnote = document.querySelector('#footnote');
        const dateString = formatDate(new Date(d.currentWeek.week_end));
        footnote.innerHTML = `Values for the week ending ${dateString}.`;
      }
      if (window.pymChild) window.pymChild.sendHeight();
    });

    // State-by-state activity
    json('https://ix.cnn.io/data/flu/v2/latest_by_date.json').then((d) => {
      if ('latestWeekId' in d && d.latestWeekId !== null) {
        // Get 50 states
        const statesFips = statesAndDc.map(x => x.fips).filter(x => x !== '11');

        // Get latest data
        const latestId = d.latestWeekId;
        const latestWeek = d.data[latestId];

        // Filter to 'high' or 'very high' and only data for states
        const veryHighOrHigh = latestWeek
          .filter(d => ((d.activityLabel == 'high') || (d.activityLabel == 'very high')))
          .filter(d => statesFips.indexOf(d.fips) > -1);

        const number = document.querySelector('#number-3');
        const unit = document.querySelector('#number-3-units');
        number.innerHTML = `${veryHighOrHigh.length}`;
        unit.innerHTML = `${veryHighOrHigh.length == 1 ? ' state' : ' states'}`;

        // Previous week
        if ('previousWeekId' in d && d.previousWeekId !== null) {
          // Get data
          const previousId = d.previousWeekId;
          const previousWeek = d.data[previousId];

          // Filter to 'high' or 'very high' and only data for states
          const veryHighOrHighPrev = previousWeek
            .filter(d => ((d.activityLabel == 'high') || (d.activityLabel == 'very high')))
            .filter(d => statesFips.indexOf(d.fips) > -1);

          const numberContext = document.querySelector('#number-3-context');

          // Compare values
          if (veryHighOrHigh.length > veryHighOrHighPrev.length) {
            numberContext.innerHTML = `, up from ${veryHighOrHighPrev.length} the previous week`;
          } else if (veryHighOrHigh.length < veryHighOrHighPrev.length) {
            numberContext.innerHTML = `, down from ${veryHighOrHighPrev.length} the previous week`;
          }
        }
      }
      if (window.pymChild) window.pymChild.sendHeight();
    });

    // Hospitalizations
    json('https://ix.cnn.io/data/flu/v2/latest_hospitalizations.json').then((d) => {
      if ('latest' in d) {
        if (d.latest.length > 0) {
          const latestWeek = d.latest.slice(-1)[0];
          const number = document.querySelector('#number-2');
          number.innerHTML = `${latestWeek.hospitalizations.toLocaleString()}`;

          const unit = document.querySelector('#number-2-units');
          unit.innerHTML = `${latestWeek.hospitalizations.length == 1 ? ' patient' : ' patients'}`;

          if (d.latest.length > 1) {
            const previousWeek = d.latest.slice(-2)[0];
            const numberContext = document.querySelector('#number-2-context');

            // Compare values
            if (latestWeek.hospitalizations > previousWeek.hospitalizations) {
              numberContext.innerHTML = `, up from ${previousWeek.hospitalizations.toLocaleString()} the previous week`;
            } else if (latestWeek.hospitalizations < previousWeek.hospitalizations) {
              numberContext.innerHTML = `, down from ${previousWeek.hospitalizations.toLocaleString()} the previous week`;
            }
          }
        }
      }
      if (window.pymChild) window.pymChild.sendHeight();
    });
  }
}
